import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { loginUser } from "../../../redux/action/auth";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { ClipLoader } from "react-spinners";
import { Link } from "react-router-dom";
import { useRef } from "react";

function LoginComponent() {
  const dispatch = useDispatch();
  const email_ref = useRef();
  const isLaptop = useMediaQuery({ query: "(max-width: 1400px)" });
  const { loading } = useSelector((state) => state.account);
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");

  const loginWithEmail = (e) => {
    e.preventDefault();
    dispatch(loginUser(email, password));
  };

  useEffect(() => {
    email_ref.current.focus();
  }, []);
  
  return (
    <div className="auth-from slide-in" style={{ width: isLaptop && "700px" }}>
      <div>
        <div className="flex justify-center ">
          <img
            src="/images/auction-image.png"
            alt="logo"
            className="auction-logo"
          />
        </div>

        <h4 className="margin-0px text-center">Sign In To Auction System</h4>
        <div className="purple lighten-5 cercle-purple-text p-1 flex mt-1">
          <i className="material-symbols-outlined">info</i>

          <p className="ml-1">
            This is a private access only. This dashboard is only for{" "}
            <b>Authorized Accounts</b>. Avoid trying to login if you do not have
            the necessary permissions
          </p>
        </div>

        <div className="mt-1">
          <form className="mt-1 " onSubmit={loginWithEmail}>
            <div className="input-field-style">
              <span className="material-symbols-outlined primary">person</span>
              <input
                ref={email_ref}
                className="browser-default "
                placeholder="Enter your email address"
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="input-field-style">
              <span className="material-symbols-outlined primary ">lock</span>
              <input
                className="browser-default input-field "
                placeholder="Enter your password"
                type={showPassword ? "text" : "password"}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <div
                onClick={() => {
                  setShowPassword(!showPassword);
                }}
                style={{ width: "25px" }}
              >
                {showPassword ? (
                  <AiFillEye className="eye-icon" />
                ) : (
                  <AiFillEyeInvisible className="eye-icon" />
                )}
              </div>
            </div>

            <div className="submit-btn mv-2 column flex align-center ">
              <button
                className="btn full-width mb-1 mt-1 "
                type="submit"
                disabled={!email || !password || loading}
              >
                {loading ? <ClipLoader color="#fff" size={20} /> : "Sign In"}
              </button>
            </div>
          </form>
        </div>

        <div className="">
          {/* <p className="semi-bold">
            Forgot password?<span className="primary"> Reset Password</span>{" "}
          </p> */}
          <p className="semi-bold">
            Don't have an account?
            <Link to={"/register/step-1"}>
              <span className="primary pointer"> Sign Up</span>
            </Link>{" "}
          </p>
        </div>
      </div>
    </div>
  );
}

export default LoginComponent;
